import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types'
import './main-page.scss';
import classNames from 'classnames'

const messageKinds = {
  'ok': ['successful', 'processing'],
  'error': ['failed', '404', '500'],
}

const MainPage = props => {
  const isErrorMessage = messageKinds['error'].includes(props.status);
  const isOkMessage = messageKinds['ok'].includes(props.status);

  const statusMessageBox = {
    'successful': (<div className="container main-page-helper-message">
      <div className="main-page-helper-message-submit">
        <div className="main-page-helper-message-submit-icon" />
        <p className="main-page-helper-message-submit-text">Подключено</p>
      </div>
    </div>),
    'processing': (<div className="container main-page-helper-message">
      <div className="main-page-helper-message-info">
        <div className="main-page-helper-message-info-icon" />
        <div className="main-page-helper-message-info-fix">
          <p className="main-page-helper-message-info-text">В течение 10 минут доступ к социально значимым ресурсам будет открыт на 7 суток.</p>
          <p className="main-page-helper-message-info-text">Пожалуйста, подождите</p>
        </div>
      </div>
    </div>),
    'failed': (<div className="container main-page-helper-message">
      <div className="main-page-helper-message-error">
        <div className="main-page-helper-message-error-icon" />
        <div className="main-page-helper-message-fix">
          <p className="main-page-helper-message-error-text">Ошибка подключения.</p>
        </div>
      </div>
    </div>),
    'foreignCitizen': (<div className="container main-page-helper-message">
      <div className="main-page-helper-message-error">
        <div className="main-page-helper-message-error-icon" />
        <div className="">
          <p className="main-page-helper-message-error-text">Вы не можете воспользоваться услугой, так как вы не являетесь гражданином РФ.</p>
          <p className="main-page-helper-message-error-text">Выйдите из текущей сессии <a className="main-page-helper-message-error-text link" href={props.esiaLink} target="_blank">Госуслуг</a> и попробуйте авторизоваться с другой учетной записью.</p>
        </div>
      </div>
    </div>),
    '404': (<div className="container main-page-helper-message">
      <div className="main-page-helper-message-error">
        <div className="main-page-helper-message-error-icon" />
        <p className="main-page-helper-message-error-text">
          Ошибка подключения. Для подключения социального интернета перейдите в <a className="main-page-helper-message-error-text link" href="https://lk.rt.ru">личный кабинет</a>
        </p>
      </div>
    </div>),
    '500': (<div className="container main-page-helper-message">
      <div className="main-page-helper-message-error">
        <div className="main-page-helper-message-error-icon" />
        <p className="main-page-helper-message-error-text">
          Ошибка подключения. Для повторной попытки перейдите в <a className="main-page-helper-message-error-text link" href="https://lk.rt.ru">личный кабинет</a>
        </p>
      </div>
    </div>),
  }

  const renderEsiaAuthLink = () => {
    if (!props.showEsiaAuthLink) return;

    return (
      <div className="main-page-second-content-left-esia-link">
        <div className="main-page-second-content-left-esia-link-icon"></div>
        <a href='/auth/esia'>
          Авторизоваться на Госуслугах
        </a>
      </div>
    );
  }

  const renderFreeResourcesPageLink = () => {
    if (!props.showFreeResourcesPageLink) return;

    return (
      <div className="main-page-second-content-left-free-resources-page-link">
        <a href={props.freeResourcesPageHref} target="_blank">
          Просмотреть список доступных сайтов
        </a>
      </div>
    );
  }

  return (
    <div className="main-page-wrapper">
      <div className="main-page-content">
        <div className="main-page-header">
          <div className="main-page-header-logo" />
        </div>
        <div className="main-page-first-content">
          <div className='main-page-first-content-left container'>
            <div className="main-page-first-content-left-text">
              <p className="main-page-first-content-left-text-one">Подключение</p>
              <p className="main-page-first-content-left-text-two">к «Социальному</p>
              <p className="main-page-first-content-left-text-three">
                <span className="main-page-first-content-left-text-three-fix-position">интернету»</span>
              </p>
            </div>
            <button className={classNames("main-page-first-content-left-button", { 'hidden': isErrorMessage || isOkMessage })}
              onClick={() => window.location.href = props.lkLink}
              disabled={isErrorMessage}
            >
              <span className="main-page-first-content-left-button-text">Войти в личный кабинет</span>
            </button>
          </div>

          <div className="main-page-first-content-right">
            <div className="main-page-first-content-middle-vector" />
            <img className="main-page-first-content-right-img" src={require('./images/photo.jpg')} />
          </div>
        </div>

        {statusMessageBox[props.status]}

        <div className={classNames("main-page-second-content", 'container', { 'helper-message': props.status !== null })}>
          <div className="main-page-second-content-left">
            <p className="main-page-second-content-left-text">
              Ростелеком предоставляет бесплатный доступ к социально значимым сайтам, зайти на которые можно даже с нулевым балансом счёта.
            </p>
            <p className="main-page-second-content-left-text">
              В <a className="main-page-second-content-left-link" href={props.freeResourcesPageHref} target="_blank">список ресурсов</a> с бесплатным доступом входят государственные порталы («Госуслуги», сайты министерств, ведомств и местных органов власти), соцсети и другие значимые информационные ресурсы.
            </p>
            <p className="main-page-second-content-left-text">
              Чтобы получить доступ ко всем ресурсам интернета <a className="main-page-second-content-left-link" href={props.turnOffLink}>отключите</a> опцию «Социальный интернет», проверьте достаточность средств на счете и пополните его при необходимости.
            </p>
            <p className="main-page-second-content-left-text">
              Чтобы воспользоваться опцией «Социальный интернет» необходима авторизация на портале государственных услуг.
            </p>
            {renderEsiaAuthLink()}
            {renderFreeResourcesPageLink()}
          </div>
        </div>
      </div>
      <div className="main-page-footer">
        <span className="main-page-footer-first-text main-page-footer-transparent-text">
          Продолжая пользование сайтом, высоглашаетесь на обработку файлов&nbsp;
          <a className="main-page-footer-first-text link" href="https://rt.ru/cookie">Cookies</a>
          &nbsp;и других пользовательских данных, в соответствии с&nbsp;
          <a className="main-page-footer-first-text link" href="https://rt.ru/legal">политикой конфидицеальности</a>
        </span>
        <div className="main-page-footer-second-text">
          <span className="main-page-footer-transparent-text">
            &copy; {`${new Date().getFullYear()}`} ПАО «Ростелеком». 0+&nbsp;
          </span>
          <div>
            <span className="main-page-footer-transparent-text">
              Служба поддержки и продаж
            </span>
            <a className="tel" href={`tel:${props.technicalHotlinePhoneNumber}`}>&nbsp;{props.technicalHotlinePhoneNumber}</a>
          </div>
        </div>
      </div>
    </div>
  )
}


MainPage.defaultProps = {
  status: null,
  esiaLink: '#',
  showEsiaAuthLink: true,
  freeResourcesPageHref: '',
  showFreeResourcesPageLink: false,
  lkLink: 'https://lk.rt.ru',
  turnOffLink: 'https://lk.rt.ru',
  technicalHotlinePhoneNumber: '8 800 100 0 800'
}

MainPage.propTypes = {
  status: PropTypes.string,
  esiaLink: PropTypes.string,
  showEsiaAuthLink: PropTypes.bool,
  freeResourcesPageHref: PropTypes.string,
  showFreeResourcesPageLink: PropTypes.bool,
  lkLink: PropTypes.string,
  turnOffLink: PropTypes.string,
  technicalHotlinePhoneNumber: PropTypes.string
}

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('main-container');
  if (!container) return;

  const strProps = container.dataset['reactProps'] || '{}';
  const props = JSON.parse(strProps);
  ReactDOM.render(<MainPage {...props} />, container);
});
